export const queryKeys = {
  jobsBase: () => ["jobs"] as const,
  jobs: (filtersHash = "all") => ["jobs", filtersHash] as const,
  specExecutions: () => ["spec-executions"] as const,
  leads: () => ["leads"] as const,
  quotes: () => ["quotes"] as const,
  opportunities: () => ["opportunities"] as const,
  appointmentResults: () => ["appointment-results"] as const,
  currentUserProfile: (authUserId: string) => ["current-user-profile", authUserId] as const,
  userRole: (userId: string) => ["user-role", userId] as const,
  issues: () => ["issues"] as const,
  contractors: () => ["contractors"] as const,
  crews: () => ["crews"] as const,
  customerComms: () => ["customer-comms"] as const,
  credits: () => ["credits"] as const,
  serviceTickets: () => ["service-tickets"] as const,
  buildReviewEvents: () => ["build-review", "all-events"] as const,
  leadSources: () => ["lead-sources"] as const,
  followUpTasks: () => ["follow-up-tasks"] as const,
  consultationSessions: () => ["consultation-sessions", "in-progress"] as const,
  marketplaceOffers: () => ["marketplace-offers"] as const,
  contractorInterests: () => ["contractor-interests"] as const,
  warehouseShipments: () => ["warehouse", "shipments"] as const,
  warehouseReceiving: () => ["warehouse", "receiving"] as const,
  warehouseAllocations: () => ["warehouse", "allocations"] as const,
  warehouseStock: () => ["warehouse", "stock"] as const,
  warehouseServerPage: (resource: string, filtersHash = "all") =>
    ["warehouse", "server-page", resource, filtersHash] as const,
  warehouseSummary: () => ["warehouse", "summary"] as const,
  jobMessages: (jobId?: string, category = "general") => ["job-messages", jobId, category] as const,
  jobMessagesAll: (jobId?: string) => ["job-messages-all", jobId] as const,
  jobMessageNotifications: (userId?: string) => ["job-message-notifications", userId] as const,
} as const;

export function hashFilters(input: unknown): string {
  if (!input || typeof input !== "object") return String(input ?? "all");
  const entries = Object.entries(input as Record<string, unknown>)
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([k, v]) => [k, v ?? ""]);
  return JSON.stringify(entries);
}
